module.exports = __webpack_public_path__ + "img/saveTab.7190c90e.png";